import { MAX_NUMBER_OF_RESULTS as r } from "./help-center-articles-search19.js";
import "./help-center-articles-search21.js";
import { SUGGESTED_SEARCH_QUERY_SUBMITTED_LABEL as i } from "./help-center-articles-search22.js";
const m = (e, s) => {
  const t = u(s);
  return {
    isLoading: !1,
    loadingState: "idle",
    items: t.length > 0 ? [
      {
        name: "suggestedQueries",
        items: t
      }
    ] : [],
    selectedKeys: /* @__PURE__ */ new Set(),
    filterText: e,
    sortDescriptor: { key: "popularity", direction: "descending", column: "title" }
  };
}, u = (e) => e.results.flatMap(
  (n) => g(n)
).slice(0, r), g = (e) => e.hits.map(
  c
), c = (e) => ({
  objectID: e.objectID,
  title: e.title,
  isSuggestedQuery: !0,
  trackingLabel: i,
  highlightResult: e._highlightResult?.title?.value,
  _rankingInfo: e._rankingInfo,
  landingUrl: e.landingUrl
});
function S(e, s) {
  for (const t of e) {
    const n = t.items.findIndex((o) => o.objectID === s);
    if (n !== -1)
      return n + 1;
  }
  return 0;
}
function p(e, s) {
  return e.flatMap((t) => t.items).find((t) => t.objectID === s);
}
export {
  m as convertSuggestedQueriesResponseToComboboxItems,
  u as extractSuggestedQueries,
  p as getSearchSelectedItemFromQueryItems,
  S as getSearchSelectedItemPosition
};
//# sourceMappingURL=help-center-articles-search9.js.map
